// What an answer does, as a symbol (live test, 24 Oct 2026): a check for allow, a cross for deny, an arrow for any
// other answer. Always beside the word, never instead of it, and hidden from screen readers, which read the word.
// In Recent, an answer not yet confirmed shows where it stands instead: a send symbol while it is on its way, a
// question mark when nobody can say whether it arrived (model.ts recentMark).
import type { AnswerEffect, RecentMark } from "../lib/model";
import { IconArrow, IconCheck, IconCross, IconQuestion, IconSend } from "./Icons";

function icon(effect: RecentMark) {
  switch (effect) {
    case "allow":
      return <IconCheck />;
    case "deny":
      return <IconCross />;
    case "sending":
      return <IconSend />;
    case "unknown":
      return <IconQuestion />;
    default:
      return <IconArrow />;
  }
}

export function EffectMark({ effect }: { effect: RecentMark }) {
  return (
    <span className={`effect-mark is-${effect}`} aria-hidden="true">
      {icon(effect)}
    </span>
  );
}

/** The hold banner's first line: "Allowing in 2 s". */
export const HOLD_VERB: Record<AnswerEffect, string> = { allow: "Allowing", deny: "Denying", answer: "Answering" };
